import { select } from "@fruugo/utilities";
import { Icon } from "./components/Icon";

const state = {
  open: false,
  initialText: "",
};

export function initShowMoreContent() {
  const button = select<HTMLButtonElement>(".js-show-more-content");
  if (!button) return;

  state.initialText = button.querySelector("span")?.textContent ?? "";

  button.addEventListener(
    "click",
    (e) => e.currentTarget && toggle(e.currentTarget)
  );
}

function toggle(target: EventTarget) {
  const button = target as HTMLButtonElement;
  const text = button?.querySelector("span");
  const icon = button?.querySelector(".icon");

  const container = button.parentElement?.querySelector(".hide-extra-content");

  icon?.remove();

  if (state.open) {
    container?.classList.remove("expanded");
    if (text) text.textContent = state.initialText;
    button.appendChild(<Icon name="chevron-down" />);
  } else {
    container?.classList.add("expanded");
    if (text) text.textContent = button.dataset.toggleText ?? state.initialText;
    button.appendChild(<Icon name="chevron-up" />);
  }

  state.open = !state.open;
}
